import React from 'react';
import { Edit2, Layers, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import { HsmContact } from '../../types';
import { getContactStatusBadge } from './contactHelpers';

export interface ContactMobileCardProps {
  contact: HsmContact;
  isAdmin: boolean;
  onEdit: (contact: HsmContact) => void;
  onAssignBatch: (contact: HsmContact) => void;
  onDelete: (contactId: number) => void;
}

export function ContactMobileCard({
  contact,
  isAdmin,
  onEdit,
  onAssignBatch,
  onDelete,
}: ContactMobileCardProps) {
  return (
    <Card className="shadow-sm">
      <CardContent className="p-4 space-y-3">
        <div className="flex items-start justify-between gap-2">
          <div>
            <div className="font-medium">{contact.phoneNumber}</div>
            {contact.name && (
              <div className="text-sm text-muted-foreground">{contact.name}</div>
            )}
          </div>
          {getContactStatusBadge(contact.status)}
        </div>
        <div className="grid grid-cols-2 gap-2 text-sm">
          <div>
            <div className="text-xs text-muted-foreground">Lote</div>
            <div className="font-medium">{contact.batchName || '-'}</div>
          </div>
          <div>
            <div className="text-xs text-muted-foreground">Criado em</div>
            <div>{new Date(contact.createdAt).toLocaleDateString('pt-BR')}</div>
          </div>
        </div>
        <div className="flex gap-2 pt-2 border-t">
          <Button
            variant="outline"
            size="sm"
            className="flex-1"
            onClick={() => onEdit(contact)}
          >
            <Edit2 className="mr-2 h-4 w-4" />
            Editar
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => onAssignBatch(contact)}
          >
            <Layers className="h-4 w-4" />
          </Button>
          {isAdmin && (
            <Button
              variant="destructive"
              size="sm"
              onClick={() => onDelete(contact.id)}
            >
              <Trash2 className="h-4 w-4" />
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
